var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper_cover"},[_c('thin-navbar'),_c('div',{staticClass:"d-flex"},[_c('b-container',{staticClass:"m-auto text-center",attrs:{"fluid":_vm.fluidContainer}},[_vm._t("default")],2)],1),_c('footer',[_c('router-link',{attrs:{"to":{name: 'cgu'}}},[_vm._v(" Conditions générales d'utilisation et mentions légales ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }